import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=265931d1&scoped=true&"
import script from "./hospital.vue?vue&type=script&lang=js&"
export * from "./hospital.vue?vue&type=script&lang=js&"
import style0 from "./hospital.vue?vue&type=style&index=0&id=265931d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265931d1",
  null
  
)

export default component.exports